import React, { useState, useEffect, useRef, useCallback } from "react";
import { QRCodeCanvas  } from 'qrcode.react';
import { useReactToPrint } from "react-to-print";
import axiosInstance from "../axios_helper/axiosInstance";
import { saveAs } from 'file-saver';
import "../style/home.css";
import "../style/shop.css";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress} from "@mui/material";
import ImageModal from "../components/ImageModal";

export default function Shop2() {
  const [stockItems, setStockItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  // const [imageError, setImageError] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [totalNwt, setTotalNwt] = useState(0);
  const [downloadError, setDownloadError] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null); // Track the selected item for printing
  const printRef = useRef(null); // Reference for the item details to print
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   fetchStockItems();
  // }, [searchTerm]);

  const fetchStockItems =  useCallback(() => {
    setLoading(true); // Set loading to true
    axiosInstance.get('stock-items/?shop=2')
      .then(response => {
        const items = response.data.filter(item => 
          item.code.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const sortedItems = items.sort((a, b) => b.id - a.id);
        const totalNwt = sortedItems.reduce((sum, item) => sum + parseFloat(item.nw || 0), 0);
        setStockItems(sortedItems);
        setTotalItems(sortedItems.length);
        setTotalNwt(totalNwt);
      })
      .catch(error => {
        console.error('Error fetching stock items:', error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false
      });
  }, [searchTerm]);

  
  useEffect(() => {
    fetchStockItems();
  }, [fetchStockItems]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this stock item?")) {
      axiosInstance.delete(`stock-items/${id}/`)
        .then(() => {
          alert("Stock item deleted successfully!"); // Success message
          fetchStockItems(); // Refresh items after deletion
        })
        .catch(error => {
          console.error("Error deleting stock item:", error);
          alert("Failed to delete the stock item. Please try again."); // Error message
        });
    }
  };
  

  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  // const handleImageError = (id) => {
  //   setImageError(true);
  // };

  const downloadExcel = () => {
    axiosInstance.get('download-shop-items/2/', { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'shop_2_stock_items.xlsx');
        setDownloadError(null);
      })
      .catch(error => {
        console.error('Error downloading stock items:', error);
        setDownloadError('Failed to download Excel file. Please try again later.');
      });
  };

  // Print stock item details
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "",  // Empty title to avoid showing the title in the print
    pageStyle: `
      @page { 
        size: 100mm 13mm;  /* Exact label size */
        margin: 0;         /* No margin for the page */
      }
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
      }
    `,
  });
  
  const printItem = (item) => {
    setSelectedItem(item);
    setTimeout(() => {
      handlePrint();
    }, 0);
  };
  

  return (
    <>
      <div className="home">
        <Sidebar />
        <div className="home-container">
          <Header />
          <div className="stockitemform-container">
            <div className="name_search">
              <h2> RMJ Shop All Items (Total N.wt: {totalNwt ? (parseFloat(totalNwt).toFixed(3)) : "0.000"}g) (Total: {totalItems})</h2>
              <div className="search-bar">
                <input
                  type="text"
                  placeholder="Search by code or item..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                <SearchOutlinedIcon />
              </div>
              <Button className="add_cate_bttn"  variant="contained" onClick={downloadExcel} style={{ backgroundColor: '#6439ff', paddingLeft: '10px' }}>
                Download Excel-2
              </Button>
              {downloadError && <div style={{ color: 'red' }}>{downloadError}</div>}
            </div>
            <div className="table_item">
              <TableContainer component={Paper} style={{ maxHeight: "600px" }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell align="center">Code</TableCell>
                      <TableCell align="center">G.wt</TableCell>
                      <TableCell align="center">N.wt</TableCell>
                      <TableCell align="center">Kund</TableCell>
                      <TableCell align="center">K.amt</TableCell>
                      <TableCell align="center">Moti</TableCell>
                      <TableCell align="center">M.amt</TableCell>
                      <TableCell align="center">PO</TableCell>
                      <TableCell align="center">P.amt</TableCell>
                      <TableCell align="center">Pcs</TableCell>
                      <TableCell align="center">Supp</TableCell>
                      <TableCell align="center">Image</TableCell>
                      <TableCell align="center">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableRow>
                        <TableCell colSpan={14} align="center">
                          <CircularProgress size={30} style={{ color: "#7451f8" }} />
                        </TableCell>
                      </TableRow>
                    ) : (
                      stockItems.length > 0 ? (
                        stockItems.map((item, index) => (
                          <TableRow key={item.id}>
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell align="center">{item.code}</TableCell>
                            <TableCell align="center">{item.gw}</TableCell>
                            <TableCell align="center">{item.nw}</TableCell>
                            <TableCell align="center">{item.kundan}</TableCell>
                            <TableCell align="center">{item.k_amt}</TableCell>
                            <TableCell align="center">{item.moti}</TableCell>
                            <TableCell align="center">{item.m_amt}</TableCell>
                            <TableCell align="center">{item.po}</TableCell>
                            <TableCell align="center">{item.p_amt}</TableCell>
                            <TableCell align="center">{item.pcs}</TableCell>
                            <TableCell align="center">{item.supplier}</TableCell>
                            <TableCell align="center">
                              {item.image ? (
                                <img
                                  className="table_image"
                                  src={item.image}
                                  alt={item.code}
                                  width="40"
                                  height="40"
                                  style={{ cursor: "pointer", borderRadius: "50%" }}
                                  onClick={() => handleOpen(item.image)}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                    e.target.nextSibling.style.display = "block";
                                  }}
                                />
                              ) : null}

                              <div
                                style={{
                                  display: "none",
                                  fontSize: "12px",
                                  color: "gray"
                                }}
                              >
                                Image not available
                              </div>
                            </TableCell>
                            <TableCell align="center">
                              <Button className="delet_bttn"
                                onClick={() => handleDelete(item.id)}
                              >
                                <DeleteIcon style={{ fontSize: 28, color: "#7451f8" }} />
                              </Button>
                              <Button className="print_bttn" variant="contained" onClick={() => printItem(item)} 
                                style={{ backgroundColor: '#6439ff', padding: '2px' }}>Print</Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={14} align="center">
                            No items match your search
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
                {/* <TablePagination
                  rowsPerPageOptions={[10]} // Fixed to 10 rows per page
                  component="div"
                  count={stockItems.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
      {selectedItem && (
        <div style={{ display: "none" }}>
          <div ref={printRef}>
            <div className="label-content" style={{ 
              width: "100mm", 
              height: "13mm", 
              display: "flex", 
              flexDirection: "row", 
              justifyContent: "space-between", 
              alignItems: "center", 
              fontSize: "8px",
              fontWeight: "800",
              padding: "2mm",
              marginTop: "-3px" 
              // boxSizing: "border-box"
            }}>
              <div>
                <p style={{ margin: 0 }}></p>
              </div>
              <div>
                <p style={{ margin: 0 }}></p>
              </div>
              <div style={{ flex: 0.5 }}> {/* Takes up remaining space */}
                <p style={{ margin: 0, textAlign: "right", }}>{selectedItem.supplier}</p>
              </div>
              <div style={{ marginLeft: "35px", marginRight: "-10px"}}>
                <p style={{ margin: 0 }}>Code : {selectedItem.code}</p>
                <p style={{ margin: 0 }}>G.wt. : {selectedItem.gw}</p>
                <p style={{ margin: 0 }}>N.wt. : {selectedItem.nw}</p>
              </div>
              <div style={{ marginLeft: "10px", marginRight: "-25px"}}>
                <QRCodeCanvas value={String(selectedItem.nw)} size={20} />
                <div >
                <p style={{ marginBottom: "-4px" }}>{selectedItem.pcs}</p>
                </div>
              </div>
              <div style={{ marginLeft: "30px", paddingRight: "1px", borderRight: "1px solid #000"}}>
                <p style={{ margin: 0 }}>K ={selectedItem.kundan}</p>
                <p style={{ margin: 0 }}>M ={selectedItem.moti}</p>
                <p style={{ margin: 0 }}>P ={selectedItem.po}</p>
              </div>
              <div style={{ marginLeft: "-14px"}}>
                <p style={{ margin: 0 }}>K ={selectedItem.k_amt}</p>
                <p style={{ margin: 0 }}>M ={selectedItem.m_amt}</p>
                <p style={{ margin: 0 }}>P ={selectedItem.p_amt}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      <ImageModal open={open} handleClose={handleClose} imageUrl={selectedImage} />
    </>
  );
}
